import React, { useEffect, useState } from 'react';
import logo from './assets/logo.png';
import success from './assets/success.png';
import oos from './assets/oos.png';

import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import useFuseStatus from "./hooks/useFuseStatus";

// Import new components
import Hero from './components/Hero';
import Stats from './components/Stats';
import Products from './components/Products';
import Mission from './components/Mission';
import Team from './components/Team';
import SocialProof from './components/SocialProof';
import Footer from './components/Footer';

function Header() {
    return (
        <div className="flex pb-5 justify-between items-center">
            <img alt="Fuse Robotics" className="w-20" src={logo} />
            <div className="flex justify-end items-center gap-8 text-white md:text-lg">
                <a className="hidden md:block hover:text-fuse-orange transition-colors" href="#products">Products</a>
                <a className="hidden md:block hover:text-fuse-orange transition-colors" href="#about">About</a>
                <a className="hidden md:block hover:text-fuse-orange transition-colors" href="#success">Success</a>
                <a className="hidden md:block hover:text-fuse-orange transition-colors" href="//twitter.com/fuserobotics" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a className="bg-fuse-orange pl-6 pr-6 pt-2 pb-2 rounded-full hover:opacity-90 transition-opacity" href="//dash.fuserobotics.io">Dashboard</a>
            </div>
        </div>
    )
}

function Landing() {
    return (
        <div className="flex flex-col gap-12 md:gap-16">
            <Hero />
            <Stats />
            <div className="flex flex-col gap-20 md:gap-24">
                <Products />
                <Mission />
                <Team />
                <SocialProof />
            </div>
        </div>
    )
}

function UpdateSuccess() {
    return (
        <div className="text-center text-xl text-white flex justify-center items-center gap-5 flex-col">
            <img src={success} alt="Success" className="w-32" />
            Fuse Chrome has been successfully updated.
            <br />
            The extension will now automatically reload to apply all changes.
        </div>
    )
}

function UpdateFailed() {
    return (
        <div className="text-center text-xl text-white flex justify-center items-center gap-5 flex-col">
            <img src={oos} alt="Success" className="w-32" />
            Fuse Chrome is not installed, please open this URL in the browser where the extension is installed or reload the extension manually.
        </div>
    )
}

function UpdateLoading() {
    return (
        <div className="text-center text-xl text-white">
            Fetching installation status...
        </div>
    )
}

function Update() {
    const installed = useFuseStatus()
    const [loaded, setLoaded] = useState(false)
    useEffect(() => {
        setTimeout(() => setLoaded(true), 1000)
    })

    return (
        <div className="flex justify-center items-center">
            {
                !loaded ? UpdateLoading() : installed ? UpdateSuccess() : UpdateFailed()
            }
        </div>
    )
}

function App() {
    // Add smooth scrolling
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth';
        return () => {
            document.documentElement.style.scrollBehavior = 'auto';
        };
    }, []);

    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <div className="bg-bg-light pl-5 pr-5 flex flex-col min-h-screen w-auto pt-10 pb-5 gap-10 md:pl-20 md:pr-20">
                        <Header />
                        <Landing />
                        <Footer />
                    </div>
                </Route>
                <Route exact path="/update">
                    <div className="bg-bg-light pl-5 pr-5 flex flex-col justify-between min-h-screen w-auto pt-10 pb-5 gap-10 md:pl-20 md:pr-20">
                        <Header />
                        <Update />
                        <Footer />
                    </div>
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
